import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrFlex from 'client/components/SrFlex';
import SrBox from 'client/components/SrBox';
import SrLogo, {
  SR_LOGO_THEME_REDESIGN,
} from 'client/components/SrLogo';

const SrLocatorToursNavbar = ({
  children,
  withLogo,
  withTopPadding,
  noBackground,
  align,
  cornerNode,
  redirectTo,
}) => (
  <div
    className={
      classnames(
        'SrLocatorToursNavbar',
        withTopPadding && 'withTopPadding',
        noBackground && 'noBackground'
      )
    }
  >
    <SrFlex direction='colReverse' className='inner'>
      <div className='margin-left-right-20'>
        <SrBox paddingBottom='3px' position='relative'>
          {withLogo && (
            <SrBox paddingBottom='11px'>
              <SrLogo
                redirectTo={redirectTo}
                disableRedirect={!redirectTo}
                align={align}
                theme={SR_LOGO_THEME_REDESIGN}
              />
            </SrBox>
          )}
          {children}
          {cornerNode && (
            <SrBox position='absolute' right='0' bottom='10px'>
              {cornerNode}
            </SrBox>
          )}
        </SrBox>
      </div>
    </SrFlex>
  </div>
);

SrLocatorToursNavbar.propTypes = {
  align: PropTypes.string,
  withLogo: PropTypes.bool,
  children: PropTypes.node,
  cornerNode: PropTypes.node,
};

SrLocatorToursNavbar.defaultProps = {
  align: 'left',
};

SrLocatorToursNavbar.displayName = 'SrLocatorToursNavbar';

export default SrLocatorToursNavbar;
